module.exports = __webpack_public_path__ + "static/media/reddit.54e20fb6.svg";